<div id="theme_id" class="">
    <app-header></app-header>
    <section class="section bg-home home-half" id="home" data-image-src="./assets/landing/images/bg-landing.jpg">
        <div class="bg-overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                    <h1 class="home-title">Bienvenido a nuestro</h1>
                    <h1 class="home-title">Portal Web de Servicios WTW</h1>
                </div>
            </div>
        </div>
    </section>

    <!-- <app-client></app-client> -->
    <app-services></app-services>
    <!-- <app-description></app-description> -->
    <!-- <app-testi></app-testi> -->
    <!-- <app-getstart></app-getstart> -->
    <app-blog></app-blog>
    <app-contact></app-contact>

    <app-footer-lan></app-footer-lan>
</div>